import * as React from 'react';
import styles from './LayoutCentral.module.css';
export function LayoutCentral(props) {
    return (React.createElement("div", { className: styles.layoutContainer }, props.children));
}
